import { render, staticRenderFns } from "./AffiliatesListing.vue?vue&type=template&id=c9e4469c"
import script from "./AffiliatesListing.vue?vue&type=script&lang=ts"
export * from "./AffiliatesListing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports